"use client"
import { TableHeader, TableHeaderCell, TextLabel } from "@opensea/ui-kit"
import { useFormContext, useWatch } from "react-hook-form"
import { useTranslations } from "use-intl"
import type { CreateCollectionOfferFormValues } from "../../types"
import { CREATE_COLLECTION_OFFER_FLOW_TABLE_CLASSNAMES } from "./constants"

export const CreateCollectionOfferFlowTableHeader = () => {
  const t = useTranslations("wallet.CreateCollectionOfferFlowTable")
  const { control } = useFormContext<CreateCollectionOfferFormValues>()
  const offers = useWatch({ control, name: "offers" })
  const firstOffer = offers[0]

  return (
    <TableHeader className="h-7 overflow-visible bg-transparent">
      <TableHeaderCell
        className={CREATE_COLLECTION_OFFER_FLOW_TABLE_CLASSNAMES.collection}
      >
        <TextLabel size="2xs">{t("collection")}</TextLabel>
      </TableHeaderCell>
      <TableHeaderCell
        className={CREATE_COLLECTION_OFFER_FLOW_TABLE_CLASSNAMES.floor}
      >
        <TextLabel size="2xs">{t("floor")}</TextLabel>
      </TableHeaderCell>
      {(firstOffer?.trait ||
        (firstOffer?.traits && firstOffer.traits.length > 0)) && (
        <TableHeaderCell
          className={CREATE_COLLECTION_OFFER_FLOW_TABLE_CLASSNAMES.traitFloor}
        >
          <TextLabel size="2xs">{t("traitFloor")}</TextLabel>
        </TableHeaderCell>
      )}
      <TableHeaderCell
        className={CREATE_COLLECTION_OFFER_FLOW_TABLE_CLASSNAMES.bestOffer}
      >
        <TextLabel size="2xs">{t("topOffer")}</TextLabel>
      </TableHeaderCell>
      {(firstOffer?.trait ||
        (firstOffer?.traits && firstOffer.traits.length > 0)) && (
        <TableHeaderCell
          className={
            CREATE_COLLECTION_OFFER_FLOW_TABLE_CLASSNAMES.traitBestOffer
          }
        >
          <TextLabel size="2xs">{t("topTraitOffer")}</TextLabel>
        </TableHeaderCell>
      )}
      <TableHeaderCell
        className={CREATE_COLLECTION_OFFER_FLOW_TABLE_CLASSNAMES.proceeds}
      >
        <TextLabel size="2xs">{t("offerTotal")}</TextLabel>
      </TableHeaderCell>
      <TableHeaderCell
        className={CREATE_COLLECTION_OFFER_FLOW_TABLE_CLASSNAMES.price}
      >
        <TextLabel size="2xs">{t("offeredAt")}</TextLabel>
      </TableHeaderCell>
    </TableHeader>
  )
}

export const CreateCollectionOfferFlowTableHeaderSkeleton = () => {
  const t = useTranslations("wallet.CreateCollectionOfferFlowTable")
  return (
    <TableHeader className="h-7 overflow-visible bg-transparent">
      <TableHeaderCell
        className={CREATE_COLLECTION_OFFER_FLOW_TABLE_CLASSNAMES.collection}
      >
        <TextLabel size="2xs">{t("collection")}</TextLabel>
      </TableHeaderCell>
      <TableHeaderCell
        className={CREATE_COLLECTION_OFFER_FLOW_TABLE_CLASSNAMES.floor}
      >
        <TextLabel size="2xs">{t("floor")}</TextLabel>
      </TableHeaderCell>
      <TableHeaderCell
        className={CREATE_COLLECTION_OFFER_FLOW_TABLE_CLASSNAMES.bestOffer}
      >
        <TextLabel size="2xs">{t("topCollectionOffer")}</TextLabel>
      </TableHeaderCell>
      <TableHeaderCell
        className={CREATE_COLLECTION_OFFER_FLOW_TABLE_CLASSNAMES.proceeds}
      >
        <TextLabel size="2xs">{t("youReceive")}</TextLabel>
      </TableHeaderCell>
      <TableHeaderCell
        className={CREATE_COLLECTION_OFFER_FLOW_TABLE_CLASSNAMES.price}
      >
        <TextLabel size="2xs">{t("offerPrice")}</TextLabel>
      </TableHeaderCell>
    </TableHeader>
  )
}
